import rootReducer from '../store/Reducers';
import Store from '../store/Store';

const store: any = Store({}, rootReducer).getState();

const baseUrl = store.Application.formIOUrl;

export interface FormIOFormResponse {
  _id: string;
  created: string;
  modified: string;
  title: string;
  display: string;
  type: string;
  name: string;
  path: string;
  project: string;
  components: any[];
  owner: string;
  submissionAccess: any[];
  access: any[];
  tags: any[];
}

export async function listForms(): Promise<FormIOFormResponse[]> {
  const response = await fetch(
    `${baseUrl}/form?select=title,name&type=form&limit=100&sort=title`
  );
  const data: FormIOFormResponse[] = await response.json();

  return data;
}

export async function getForm(id: string): Promise<FormIOFormResponse> {
  const response = await fetch(createFormUrl(id));
  const data: FormIOFormResponse = await response.json();

  return data;
}

export function createFormUrl(id: string) {
  return `${baseUrl}/form/${id}`;
}
